import { IIngridApi } from '@checkout/state';
import { IShipwallet } from '../typings/state.d';

export const isShipwallet2 = (shipwallet: IShipwallet): boolean => {
  return shipwallet && shipwallet.version === 2 && shipwallet.snippet !== '';
};

export const ingridSuspend = (suspendIgnore?: boolean) => {
  if (!!window._sw) {
    if (suspendIgnore) {
      return;
    }
    // Block user input and put up a spinner on Ingrid widget
    window._sw(function(api: IIngridApi) {
      api.suspend();
    });
  }
};

export const ingridResume = (suspendIgnore?: boolean) => {
  if (!!window._sw) {
    if (suspendIgnore) {
      return;
    }
    // Unblock Ingrid Widget
    window._sw(function(api: IIngridApi) {
      api.resume();
    });
  }
};

export const kcoSuspend = () => {
  if (!!window._klarnaCheckout) {
    // Block user input and put up a spinner on KCO widget
    window._klarnaCheckout((api: any) => api.suspend());
  }
};

export const kcoResume = () => {
  if (!!window._klarnaCheckout) {
    // Unblock KCO Widget
    window._klarnaCheckout((api: any) => api.resume());
  }
};
